/*****************************
指定されたURLの配列を読み込んだら $.Deferred を返す
***********************************/
/*
var urls = ['image1.jpg', 'image2.jpg', 'image3.jpg'];
var preload = require('./caracol2/util/preload.js');

preload( urls,{
    onProgress: function( url, total, count, percent ){
        console.log("{progress}", url, total, count, percent);
    }
})
.fail( function( url, jqXHR, textStatus, errorThrown ){
    console.log("{error}", url);
}).done( function( total, count ){
    console.log("{comp}", total, count);
});
*/

module.exports = function( list, config ){
	'use strict';

	var defaults = {
		// onProgress: function( url, total, count, percent ){}
		onProgress: null
	}
	var opt = jQuery.extend( defaults, config );

	// Deferred オブジェクト
    var defer = $.Deferred();
	var count = 0;
	var total = list.length;

	// 個々のURLを取得し、deferredオブジェクトを返す
	var promise = list.map( function( url ){
		return jQuery.get( url )
		.fail( function( jqXHR, textStatus, errorThrown ){
			defer.rejectWith( this, [url, jqXHR, textStatus, errorThrown] );
		})
		.done( function( e ){
			var percent = ( count +1 ) / total;
			if( opt.onProgress ){
				opt.onProgress( url, total, count, percent );
			}
			count ++;
		});
	});

	// 全部読み込み終わったら実行
	jQuery.when.apply( null, promise )
		.done(function () {
		defer.resolve( total, count );
	});

	// promiseオブジェクトを返して fail()、done()、always()を使えるようにする
	return defer.promise();
}
